import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useLoading, useServerError } from 'shared/hooks'
import { notificationMessageVar } from 'modulesCommon/store'

import { useDeleteArtistMutation } from 'modules/Artists/graphql/mutations'
import { Artist, GlobalProduct } from 'shared/__gql-types'

const useDeleteArtist = ({ id, artist, products }: { id: string; artist: Artist; products: GlobalProduct[] }) => {
  const [isModalOpened, setModalOpenedVar] = useState(false)
  const navigate = useNavigate()

  const [removeArtist, { loading: removeArtistLoading, error: removeArtistError }] = useDeleteArtistMutation()

  const onDelete = useCallback(() => {
    if (id) {
      removeArtist({ variables: { id } }).then(() => {
        navigate('/admin/artists')
        notificationMessageVar({
          message: 'Artist has been successfully deleted.',
          title: 'Success',
          type: 'success'
        })
      })
    }
  }, [navigate, id, removeArtist])

  const onDeleteArtist = useCallback(() => {
    if (artist.campaigns?.length || products.length) {
      notificationMessageVar({
        message: 'Artist has assigned projects or products',
        title: 'Warning',
        type: 'danger'
      })
    } else {
      setModalOpenedVar(true)
    }
  }, [artist, products])

  const onCloseModal = useCallback(() => {
    setModalOpenedVar(false)
  }, [])

  const onConfirmDelete = useCallback(() => {
    onCloseModal()
    onDelete()
  }, [onDelete, onCloseModal])

  useLoading({ isLoading: removeArtistLoading })

  useServerError([removeArtistError])

  return {
    onDelete,
    isModalOpened,
    onCloseModal,
    onDeleteArtist,
    onConfirmDelete
  }
}

export default useDeleteArtist
